export default __webpack_public_path__ + "static/media/nft14.6ad54228.png";